import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { QuoteSummary, QuoteSummaryItem } from "../../models";

interface SummaryTableProps {
  quoteSummary: QuoteSummary;
  showFeatures: boolean;
  showRate: boolean;
  showCredits: boolean;
  showTotal: boolean;
}

export const SummaryTable = (props: SummaryTableProps) => {
  return (
    <Table className="table-fixed">
      <TableHeader>
        <TableRow>
          <TableHead className="font-bold px-0 w-2/5">Dataset</TableHead>
          <TableHead className="font-bold px-0 text-right w-1/4">
            {props.showFeatures && "Features"}
          </TableHead>
          <TableHead className="font-bold px-0 text-right w-[15%]">
            {props.showRate && "Rate"}
          </TableHead>
          <TableHead className="font-bold px-0 text-right w-1/5">
            {props.showCredits && "Credits"}
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.quoteSummary.items.map((item: QuoteSummaryItem) => (
          <TableRow key={item.name}>
            <TableCell className="px-0 whitespace-normal wrap-break-word">{item.name}</TableCell>
            <TableCell className="px-0 text-right">
              {props.showFeatures && item.features.toLocaleString()}
            </TableCell>
            <TableCell className="px-0 text-right">
              {props.showRate && item.rate.toLocaleString()}
            </TableCell>
            <TableCell className="px-0 text-right">
              {props.showCredits && item.credits.toLocaleString()}
            </TableCell>
          </TableRow>
        ))}
        {props.showTotal && (
          <TableRow>
            <TableCell className="px-0 text-right font-bold">
              {(props.showCredits || props.showFeatures) && "Total"}
            </TableCell>
            <TableCell className="px-0 text-right font-bold">
              {props.showFeatures &&
                props.quoteSummary.totalFeatures.toLocaleString()}
            </TableCell>
            <TableCell className="px-0 text-right font-bold" />
            <TableCell className="px-0 text-right font-bold">
              {props.showCredits &&
                props.quoteSummary.totalCredits.toLocaleString()}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
